import axios from 'axios';
import { API_URL } from '../config/api';
import SessionService from './SessionService';

const authHeaders = () => {
  const token = SessionService.getToken();
  if (!token) throw new Error('Authentication token not found');
  return { Authorization: `Bearer ${token}` };
};

export type WebchatSiteStatus = 'active' | 'paused';

export interface WebchatSite {
  id: number;
  name: string;
  /** Chave pública (wcs_…): pode ficar no código do site. */
  publicKey: string;
  status: WebchatSiteStatus | string;
  allowedOrigins: string[];
  greeting: string | null;
  quickReplies: string[];
  /** Teto diário de clientes novos atendidos pela IA (padrão 200 quando ausente). */
  dailyAiContactLimit?: number | null;
}

export interface WebchatSiteInput {
  name: string;
  allowedOrigins: string[];
  greeting: string | null;
  quickReplies: string[];
  status: WebchatSiteStatus;
  dailyAiContactLimit?: number | null;
}

export interface WebchatSendInput {
  sectorId: number;
  contactId: number;
  text: string;
  idempotencyKey: string;
}

export const listWebchatSites = async (sectorId: number): Promise<WebchatSite[]> => {
  const response = await axios.get<WebchatSite[]>(`${API_URL}/webchat/sites`, { params: { sectorId }, headers: authHeaders() });
  return response.data;
};

export const createWebchatSite = async (sectorId: number, input: WebchatSiteInput): Promise<WebchatSite> => {
  const response = await axios.post<WebchatSite>(`${API_URL}/webchat/sites`, input, { params: { sectorId }, headers: authHeaders() });
  return response.data;
};

export const updateWebchatSite = async (sectorId: number, id: number, input: WebchatSiteInput): Promise<WebchatSite> => {
  const response = await axios.put<WebchatSite>(`${API_URL}/webchat/sites/${id}`, input, { params: { sectorId }, headers: authHeaders() });
  return response.data;
};

/** Resposta humana ao visitante do site: a mesma chave de idempotência nunca grava duas vezes. */
export const sendWebchatMessage = async (input: WebchatSendInput): Promise<{ messageId: number }> => {
  const { sectorId, ...body } = input;
  const response = await axios.post<{ messageId: number }>(`${API_URL}/webchat/messages`, body, { params: { sectorId }, headers: authHeaders() });
  return response.data;
};
